import { useTranslation as e } from "../../i18n.mjs";
import { FilePreview as t } from "../file-preview/index.mjs";
import { FilePreviewFromOS as n } from "../file-preview-from-os/index.mjs";
import { Button as r } from "@systemeio/components";
import "react";
import { twMerge as i } from "tailwind-merge";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { CheckCircleIcon as s, Pencil02Icon as c, XIcon as l } from "@systemeio/icons";
//#region src/components/file-item/file-item-base.tsx
function u({ file: u, isLoaded: d, isDeleting: f, className: p, disabled: m, disabledDeleteButton: h, showDeleteButton: g, showEditButton: _, childrenWrapper: v, childrenFileWrapper: y, onDeleteFile: b, onEdit: x }) {
	let { t: S } = e(), C = (() => {
		if (d) return /* @__PURE__ */ a(s, {
			"aria-hidden": !0,
			className: "text-icon-success bg-bg-primary animate-pop-up group absolute -top-2 -right-2 z-1 size-5 rounded-full"
		});
		if (g && b) return /* @__PURE__ */ a(r, {
			"aria-label": `${S("file_manager.delete")}: ${u.name}`,
			className: i("bg-bg-primary group absolute -top-2 -right-2 z-1 rounded-full", f && "animate-pulse"),
			onClick: (e) => {
				e.preventDefault(), e.stopPropagation(), b();
			},
			disabled: h || m,
			size: "icon-xs",
			variant: "secondary",
			children: /* @__PURE__ */ a(l, {})
		});
	})();
	return /* @__PURE__ */ o("div", {
		className: i("relative h-24 w-24", p),
		onClick: (e) => e.stopPropagation(),
		title: u.name,
		children: [
			C,
			/* @__PURE__ */ o("div", {
				className: "group/edit relative h-full w-full",
				children: [
					u instanceof File ? /* @__PURE__ */ a(n, {
						file: u,
						className: "h-full w-full rounded-md"
					}) : /* @__PURE__ */ a(t, {
						src: u.thumbnail || u.path,
						fileType: u.type,
						isThumbnail: !0,
						className: "h-full w-full rounded-md",
						title: u.name
					}),
					/* @__PURE__ */ a("div", {
						className: i("bg-alpha-gray-alpha-gray-25 absolute top-0 left-0 hidden h-full w-full cursor-auto items-center justify-center rounded-md backdrop-blur-md", _ && !m && "group-hover/edit:desktop:flex desktop:hover-capable:hidden flex"),
						children: /* @__PURE__ */ a(r, {
							"aria-label": `${S("file_manager.file_upload.crop_file")}: ${u.name}`,
							onClick: x,
							size: "icon-xs",
							variant: "secondary",
							children: /* @__PURE__ */ a(c, {})
						})
					}),
					y
				]
			}),
			v
		]
	});
}
//#endregion
export { u as FileItemBase };
